(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3242],{

/***/ 43611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _arco_design_web_react_dist_css_index_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23305);
/* harmony import */ var _arco_design_web_react_dist_css_index_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_arco_design_web_react_dist_css_index_less__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _style_globals_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21426);
/* harmony import */ var _style_globals_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_globals_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useI18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4716);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(40360);
/* harmony import */ var _hooks_useGetCsrfToken__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48795);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26638);
/* harmony import */ var _store_ssr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49780);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59544);
/* harmony import */ var _utils_userInfoCache__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25890);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(84110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(42586);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_app__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7544);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _components_Script__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(18737);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _utils_generateCookies__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(77932);
/* harmony import */ var _react_oauth_google__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(86426);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(1405);
/* harmony import */ var _pages_exception__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(46129);
/* harmony import */ var _mobile_pages_exception__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(71364);
/* harmony import */ var _style_global_less__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(1893);
/* harmony import */ var _style_global_less__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_style_global_less__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _hooks_useNProgress_index_less__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(19370);
/* harmony import */ var _hooks_useNProgress_index_less__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_hooks_useNProgress_index_less__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _mobile_pages_guide_to_pc__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(75069);
/* harmony import */ var _utils_cookie__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(39533);
/* harmony import */ var _components_SEOHeader__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(47742);
/* harmony import */ var _hooks_useLoading__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(94982);
/* harmony import */ var _components_GlobalLoading__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(83889);
/* harmony import */ var _utils_seo__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(27989);
/* harmony import */ var _hooks_useIntercom__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(94303);
/* harmony import */ var _hooks_useInviteCode__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(42844);
/* harmony import */ var _hooks_useBdVid__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(63128);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _components_ErrorBoundary__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(13156);
/* harmony import */ var _hooks_useRouteBack__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(20074);
/* harmony import */ var _utils_region__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(37101);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















 // import PcLayout from '@/components/Layout'
// import MobileLayout from '@/mobile-components/MobileLayout'
















 // import useNotify from '@/hooks/useNotify'











const MobileLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_34___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(1389), __webpack_require__.e(9458), __webpack_require__.e(9460), __webpack_require__.e(1077), __webpack_require__.e(9317), __webpack_require__.e(7610), __webpack_require__.e(9583), __webpack_require__.e(9352), __webpack_require__.e(3750), __webpack_require__.e(3582), __webpack_require__.e(231), __webpack_require__.e(3973), __webpack_require__.e(5484), __webpack_require__.e(4360), __webpack_require__.e(1402)]).then(__webpack_require__.bind(__webpack_require__, 73877)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(73877)]
  }
});
const PcLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_34___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(1389), __webpack_require__.e(8096), __webpack_require__.e(4592), __webpack_require__.e(9458), __webpack_require__.e(2403), __webpack_require__.e(9460), __webpack_require__.e(3601), __webpack_require__.e(5976), __webpack_require__.e(4059), __webpack_require__.e(9583), __webpack_require__.e(8159), __webpack_require__.e(9352), __webpack_require__.e(3787), __webpack_require__.e(8263), __webpack_require__.e(155), __webpack_require__.e(175), __webpack_require__.e(6588), __webpack_require__.e(1649), __webpack_require__.e(4360), __webpack_require__.e(9646), __webpack_require__.e(8707)]).then(__webpack_require__.bind(__webpack_require__, 5974)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(5974)]
  }
});
dayjs__WEBPACK_IMPORTED_MODULE_11___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_12___default()));

const CustomApp = props => {
  const {
    Component,
    pageProps
  } = props;
  const {
    lang,
    currency,
    isMobile,
    host,
    showMemberModal: showMemberModalFromSSR,
    memberModalClosable: memberModalClosableFromSSR
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(state => state.ssr);
  const i18n = (0,_hooks_useI18n__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  dayjs__WEBPACK_IMPORTED_MODULE_11___default().locale(i18n.dayjs);
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_15__.useRouter)();
  const [loading] = (0,_hooks_useLoading__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(); // 获取token

  (0,_hooks_useGetCsrfToken__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
  (0,_hooks_useInviteCode__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)();
  (0,_hooks_useBdVid__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .ZP)();
  const {
    isIntercomLoad
  } = (0,_hooks_useIntercom__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)({
    lang
  });
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    // 2022.4.2版本起，前端不再缓存 userinfo，故将以前存在 localstorage 中的 userinfo cache 清楚
    if (_utils_userInfoCache__WEBPACK_IMPORTED_MODULE_10__/* ["default"].getCache */ .Z.getCache()) {
      _utils_userInfoCache__WEBPACK_IMPORTED_MODULE_10__/* ["default"].resetCache */ .Z.resetCache();
    }
  }, []);
  const contextValue = {
    lang,
    currency,
    showMemberModalFromSSR,
    memberModalClosableFromSSR,
    isIntercomLoad
  };
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    document.documentElement.lang = lang;
  }, [lang]); // 监听回退事件

  (0,_hooks_useRouteBack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)(); // TODO: 后端接口还未上线
  // useNotify()

  const renderHead = () => {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_13___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)("meta", {
        charSet: "UTF-8"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)("link", {
        rel: "shortcut icon",
        type: "image/x-icon",
        href: "https://static.echotik.live/assets/icon.ico"
      }), (0,_utils_seo__WEBPACK_IMPORTED_MODULE_30__/* .RenderCanonical */ ._)(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)("meta", {
        httpEquiv: "X-UA-Compatible",
        content: "ie=edge"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)("title", {
        children: _components_SEOHeader__WEBPACK_IMPORTED_MODULE_27__/* .SEOConfig.title */ .i.title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)("meta", {
        name: "keywords",
        content: _components_SEOHeader__WEBPACK_IMPORTED_MODULE_27__/* .SEOConfig.keywords */ .i.keywords
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)("meta", {
        name: "description",
        content: _components_SEOHeader__WEBPACK_IMPORTED_MODULE_27__/* .SEOConfig.description */ .i.description
      }), isMobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0"
      })]
    });
  };

  const renderException = () => {
    return isMobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(_mobile_pages_exception__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
      code: pageProps.errorCode,
      message: pageProps === null || pageProps === void 0 ? void 0 : pageProps.message
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(_pages_exception__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
      code: pageProps.errorCode,
      message: pageProps === null || pageProps === void 0 ? void 0 : pageProps.message
    });
  };

  const renderPage = () => {
    const isAdaptMobile = ['/login', '/login/wx', '/register', '/onboarding', '/board', '/influencers/', '/products/', '/live/', '/videos/', '/shops/', '/influencers/leaderboard/', '/products/leaderboard/', '/search', '/user', '/pricing', '/index/product', 'index/influencer', '/[influencers_category]/page', '/[products_category]/page', '/sitemap/', '/tool/ai', '/tools', '/tool/calculator'].some(path => router.pathname.startsWith(path));
    const hasLayout = !['/login', '/login/wx', '/register', '/forgot-password', '/modify-password', '/onboarding', '/search'].includes(router.pathname);
    const Layout = isMobile && isAdaptMobile ? MobileLayout : PcLayout;
    const Wrapper = hasLayout ? Layout : react__WEBPACK_IMPORTED_MODULE_4__.Fragment;
    const children = pageProps.errorCode ? renderException() : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(Component, _objectSpread({}, pageProps));
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(_components_GlobalLoading__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
      loading: loading,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(Wrapper, {
        children: isMobile && !isAdaptMobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(_mobile_pages_guide_to_pc__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
          children: children
        }) : children
      })
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsxs)(_components_ErrorBoundary__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
    children: [renderHead(),  true ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(_components_Script__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
      lang: lang
    }) : 0, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_38___default()), {
      strategy: "lazyOnload",
      src: "https://turing.captcha.qcloud.com/TJCaptcha.js"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .ZP, {
      locale: i18n.arco,
      componentConfig: {
        Card: {
          bordered: false
        },
        List: {
          bordered: false
        },
        Table: {
          border: false
        }
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(_context__WEBPACK_IMPORTED_MODULE_9__/* .GlobalContext.Provider */ .kn.Provider, {
        value: contextValue,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_39__.jsx)(_react_oauth_google__WEBPACK_IMPORTED_MODULE_19__/* .GoogleOAuthProvider */ .rg, {
          clientId: _utils_constants__WEBPACK_IMPORTED_MODULE_41__/* .GOOGLE_CLIENT_ID */ .wL,
          children: renderPage()
        })
      })
    })]
  });
};

CustomApp.getInitialProps = _store__WEBPACK_IMPORTED_MODULE_7__/* .wrapper.getInitialAppProps */ .Y.getInitialAppProps(store => async context => {
  var _context$ctx$req, _context$ctx$req2, _context$ctx$req3, _context$ctx$req4;

  const cookies = (0,cookies_next__WEBPACK_IMPORTED_MODULE_17__.getCookies)(context.ctx);
  const token = cookies.token ? decodeURIComponent(cookies.token) : '';
  const isFirstVisit = cookies.is_first_visit;
  const {
    language,
    currency,
    region
  } = await (0,_utils_generateCookies__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
    acceptLanguage: ((_context$ctx$req = context.ctx.req) === null || _context$ctx$req === void 0 ? void 0 : _context$ctx$req.headers['x-accept-language']) || ((_context$ctx$req2 = context.ctx.req) === null || _context$ctx$req2 === void 0 ? void 0 : _context$ctx$req2.headers['accept-language']),
    languageFromCookie: cookies.lang,
    currencyFromCookie: cookies.currency,
    regionFromCookie: cookies.region,
    token
  });
  let currentRegion = region; // 因为 AWS 服务器，复写了原始的 ua 头
  // 所以新增 x-user-agent，是由 nginx 层，复制出来 ua 头

  const ua = ((_context$ctx$req3 = context.ctx.req) === null || _context$ctx$req3 === void 0 ? void 0 : _context$ctx$req3.headers['x-user-agent']) || ((_context$ctx$req4 = context.ctx.req) === null || _context$ctx$req4 === void 0 ? void 0 : _context$ctx$req4.headers['user-agent']);
  const {
    res,
    req
  } = context.ctx;

  if (isFirstVisit !== 'false') {
    // 说明是第一次访问, region强制设置成US
    currentRegion = _utils_region__WEBPACK_IMPORTED_MODULE_37__/* .Region.US */ .y.US;
    (0,_utils_cookie__WEBPACK_IMPORTED_MODULE_26__/* .setCookieWithMaxAge */ .V)(_utils_constants__WEBPACK_IMPORTED_MODULE_41__/* .IS_FIRST_VISIT_COOKIE */ .fJ, 'false', {
      req,
      res
    });
    (0,_utils_cookie__WEBPACK_IMPORTED_MODULE_26__/* .setCookieWithMaxAge */ .V)(_utils_constants__WEBPACK_IMPORTED_MODULE_41__/* .REGION_COOKIE */ .jO, _utils_region__WEBPACK_IMPORTED_MODULE_37__/* .Region.US */ .y.US, {
      req,
      res
    });
  } else {
    (0,_utils_cookie__WEBPACK_IMPORTED_MODULE_26__/* .setCookieWithMaxAge */ .V)(_utils_constants__WEBPACK_IMPORTED_MODULE_41__/* .REGION_COOKIE */ .jO, currentRegion, {
      req,
      res
    });
  }

  store.dispatch(_store_ssr__WEBPACK_IMPORTED_MODULE_8__/* .actions.updateSsrStoreAction */ .Nw.updateSsrStoreAction({
    token,
    lang: language,
    currency,
    region: currentRegion,
    isMobile: (0,_utils_is__WEBPACK_IMPORTED_MODULE_20__/* .isMobile */ .tq)(ua),
    host: req === null || req === void 0 ? void 0 : req.headers.host,
    ua
  }));
  (0,_utils_cookie__WEBPACK_IMPORTED_MODULE_26__/* .setCookieWithMaxAge */ .V)(_utils_constants__WEBPACK_IMPORTED_MODULE_41__/* .CURRENCY_COOKIE */ .SM, currency, {
    req,
    res
  });
  (0,_utils_cookie__WEBPACK_IMPORTED_MODULE_26__/* .setCookieWithMaxAge */ .V)(_utils_constants__WEBPACK_IMPORTED_MODULE_41__/* .LANG_COOKIE */ .Yk, language, {
    req,
    res
  });
  return await next_app__WEBPACK_IMPORTED_MODULE_14__["default"].getInitialProps(context);
});
/* harmony default export */ __webpack_exports__["default"] = (_store__WEBPACK_IMPORTED_MODULE_7__/* .wrapper.withRedux */ .Y.withRedux(CustomApp));

/***/ }),

/***/ 74169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ getCsrfCookieApi; },
/* harmony export */   "FK": function() { return /* binding */ getCommentAnalysisApi; },
/* harmony export */   "GR": function() { return /* binding */ getDataUpdateTimeApi; },
/* harmony export */   "H6": function() { return /* binding */ updateUserApi; },
/* harmony export */   "Hx": function() { return /* binding */ getMemberDiscountCodeApi; },
/* harmony export */   "Iu": function() { return /* binding */ getGoogleInfo; },
/* harmony export */   "KZ": function() { return /* binding */ postManageSubscribeApi; },
/* harmony export */   "PJ": function() { return /* binding */ getAiMenuConfig; },
/* harmony export */   "QY": function() { return /* binding */ getProductAnalysisLeftTimesApi; },
/* harmony export */   "SW": function() { return /* binding */ getTranslateApi; },
/* harmony export */   "Sg": function() { return /* binding */ getMemberPlansApi; },
/* harmony export */   "V1": function() { return /* binding */ postStripePlansApi; },
/* harmony export */   "V3": function() { return /* binding */ getSearchApi; },
/* harmony export */   "WE": function() { return /* binding */ getExportLogsApi; },
/* harmony export */   "Wb": function() { return /* binding */ sendEmailApi; },
/* harmony export */   "XF": function() { return /* binding */ getUserApi; },
/* harmony export */   "Yf": function() { return /* binding */ postTencentCaptchaApi; },
/* harmony export */   "Yl": function() { return /* binding */ postWxPayApi; },
/* harmony export */   "ZH": function() { return /* binding */ updatePasswordApi; },
/* harmony export */   "a7": function() { return /* binding */ updateGlobalConfigApi; },
/* harmony export */   "cd": function() { return /* binding */ getDiscountCodeApi; },
/* harmony export */   "fN": function() { return /* binding */ getSearchHotApi; },
/* harmony export */   "fh": function() { return /* binding */ getWelfareCenterCategoryApi; },
/* harmony export */   "gp": function() { return /* binding */ getPlansDetailApi; },
/* harmony export */   "jQ": function() { return /* binding */ bindAuthApi; },
/* harmony export */   "mF": function() { return /* binding */ updateUserEmailApi; },
/* harmony export */   "nQ": function() { return /* binding */ postAliPayApi; },
/* harmony export */   "nz": function() { return /* binding */ getAffiliateApi; },
/* harmony export */   "rC": function() { return /* binding */ getCreditPlans; },
/* harmony export */   "se": function() { return /* binding */ getManualService; },
/* harmony export */   "ty": function() { return /* binding */ getBannerApi; },
/* harmony export */   "uI": function() { return /* binding */ getDownloadVideoLeftTimesApi; },
/* harmony export */   "vs": function() { return /* binding */ getCommentFilterApi; },
/* harmony export */   "wP": function() { return /* binding */ postGetInvoice; },
/* harmony export */   "yd": function() { return /* binding */ getSystemUpdateApi; },
/* harmony export */   "zi": function() { return /* binding */ getWelfareCenterApi; }
/* harmony export */ });
/* unused harmony exports getNotificationApi, getAiMenus, getDownloadVideoApi */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84425);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // 获取跨域cookie接口，无 /api/v1 前缀

const getCsrfCookieApi = async token => {
  const baseOrigin =  false ? 0 : '';
  const instance = axios__WEBPACK_IMPORTED_MODULE_2___default().create();
  instance.defaults.baseURL = baseOrigin;
  instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  return instance.get('/api/csrf-cookie');
};
const getUserApi = async config => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/users', config);
};
const updateUserApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].put */ .ZP.put('/users', params);
}; // 检查系统更新

const getSystemUpdateApi = async () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/system/updates');
};
const getDataUpdateTimeApi = config => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/data/updates', config);
};
const updateUserEmailApi = params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/users/verify', params);
};
const updatePasswordApi = params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/users/changepwd', params);
};
const sendEmailApi = params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/users/sendmail', params);
};
const updateGlobalConfigApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].put */ .ZP.put('users/global-config', params);
};
const getGoogleInfo = token => {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().create().get('https://www.googleapis.com/oauth2/v3/userinfo', {
    headers: {
      Authorization: `Bearer ${token}`
    },
    withCredentials: false
  });
};
const bindAuthApi = (platform, params) => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post(`/auth/${platform}/binding`, params);
}; // 搜索推荐

const getSearchHotApi = async config => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/data/influencers/search/list', config);
};
const getSearchApi = (type, params, config) => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/search/${type}`, Object.assign({
    params
  }, config));
}; // 翻译查询

const getTranslateApi = async (params, config) => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/tools/translation', _objectSpread({
    params
  }, config));
};
const getNotificationApi = async () => {
  return request.get('/users/notification');
}; // 收费方案,自定义子账号价格

const getMemberPlansApi = async function () {
  let quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let config = arguments.length > 1 ? arguments[1] : undefined;
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/member/plans', Object.assign({
    params: {
      quantity
    }
  }, config));
}; // 收费明细

const getPlansDetailApi = async config => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/member/plans/items', config);
};
const getManualService = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/member/manual-trial', {
    params
  });
};
const getAiMenus = async () => {
  return request.get('/tools/navigation-ai');
};
const getAiMenuConfig = async () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/common/menu-config');
}; // 购买直播，视频次数

const getCreditPlans = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/member/credit-plans', {
    params
  });
}; // 立即购买

const postStripePlansApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/stripe/credits-payment', params);
}; // 管理订阅

const postManageSubscribeApi = async () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/stripe/create-portal-session');
}; //成为推荐官

const getAffiliateApi = async config => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/users/partner-share', config);
}; // 导出日志

const getExportLogsApi = params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/users/export/records', {
    params
  });
}; // 微信支付

const postWxPayApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/wechat/wxpay', _objectSpread({}, params));
}; // 支付宝支付

const postAliPayApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/alipay/pay', _objectSpread({}, params));
}; // 折扣码

const getDiscountCodeApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/member/discount-price', {
    params
  });
}; // 腾讯云验证码

const postTencentCaptchaApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/tools/captcha', params);
}; // 下载无水印视频

const getDownloadVideoApi = id => {
  return request.get(`/tools/video/download?video_id=${id}`);
}; // 下载视频剩余次数

const getDownloadVideoLeftTimesApi = () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/tools/video/quota');
}; // 货盘使用次数

const getProductAnalysisLeftTimesApi = () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/tools/huopan/quota');
}; // 获取折扣码

const getMemberDiscountCodeApi = () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/member/discount-code`);
}; //开发票

const postGetInvoice = params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/order/invoice', _objectSpread(_objectSpread({}, params), {}, {
    skipCodeCheck: true
  }));
}; // 获取福利中心

const getWelfareCenterApi = params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/welfare/welfare-center/${params.tag}`, {
    params: {
      page: params.page,
      per_page: params.per_page,
      type_id: params.type_id
    }
  });
}; // 运营干货 分类

const getWelfareCenterCategoryApi = () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/welfare/welfare-type');
}; // 获取轮播图数据

const getBannerApi = () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('/banner/board');
}; // 评论筛选

const getCommentFilterApi = id => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/products/${id}/comments-filters`);
}; // 评论分级统计

const getCommentAnalysisApi = (id, params) => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/products/${id}/comments-analysis`, {
    params
  });
};

/***/ }),

/***/ 84425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KA": function() { return /* binding */ backendCodeProcessor; },
/* harmony export */   "RU": function() { return /* binding */ baseOrigin; },
/* harmony export */   "Y0": function() { return /* binding */ parseBlurRes; },
/* harmony export */   "_8": function() { return /* binding */ generateSsrCtx; },
/* harmony export */   "v2": function() { return /* binding */ baseURL; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29735);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80507);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42586);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1405);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_checkLogin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23199);
/* harmony import */ var _store_ssr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49780);
/* harmony import */ var _api_tiktok_shop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47329);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









const backendCodeProcessor = (res, config) => {
  const {
    store,
    memberModalClosable = false,
    defaultValue
  } = config || {};

  if ([_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .UNAUTHORIZED_CODE */ .BT].includes(res.data.code)) {
    var _res$data;

    store === null || store === void 0 ? void 0 : store.dispatch(_store_ssr__WEBPACK_IMPORTED_MODULE_5__/* .actions.updateSsrStoreAction */ .Nw.updateSsrStoreAction({
      showMemberModal: true,
      memberModalClosable
    }));
    return (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || defaultValue || {};
  }

  if ([_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SUCCESS_CODE */ .Gh, _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .BLUR_CODE */ .HH].includes(res.data.code)) {
    return res.data.data;
  }

  if ([_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .NOT_VERIFIED */ .MC].includes(res.data.code)) {
    return Promise.reject(res);
  }

  if ([_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .TIKTOK_SHOP_UNAUTHORIZED_CODE */ ._w, _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .TIKTOK_SHOP_EXPIRED_CODE */ .yL].includes(res.data.code)) {
    (0,_api_tiktok_shop__WEBPACK_IMPORTED_MODULE_6__/* .getTiktokShopUrl */ .E6)().then(res => {
      if (res.data.data.auth_url) {
        // 跳转到 TikTok 店铺授权链接进行授权
        window.location.href = res.data.data.auth_url;
      }
    }).finally(() => {
      return Promise.reject(res);
    });
  }

  if (!_utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF && [_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .MULTIPLE_LOGIN_CODE */ .QK].includes(res.data.code)) {
    var _res$data2, _res$data3;

    _arco_design_web_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"].warning */ .Z.warning({
      title: `${res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.msg}`,
      content: `${res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.msg}` || 'Sorry, your account has been logged in on other devices. Please try again.',
      onOk: () => {
        (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_4__/* .deleteToken */ .pQ)();
        window.location.href = '/login';
      },
      onCancel: () => {
        (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_4__/* .deleteToken */ .pQ)();
      },
      afterClose: () => {
        (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_4__/* .deleteToken */ .pQ)();
        window.location.href = '/login';
      }
    });
    return Promise.reject(res);
  }

  return Promise.reject(res);
};
const parseBlurRes = _ref => {
  var _data$data, _data$data2;

  let {
    data,
    error,
    loading
  } = _ref;
  return {
    data: (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.data) || [],
    error,
    loading,
    blur: (data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .BLUR_CODE */ .HH,
    rawData: data
  };
};
const generateSsrCtx = storeState => {
  const {
    lang,
    currency,
    token,
    region,
    ua
  } = storeState.ssr;
  const ssrCtx = {
    lang,
    currency,
    token,
    region,
    ua
  };
  return ssrCtx;
}; // 基础url

const baseOrigin =  false ? 0 : 'https://echotik.live';
const baseURL = `${baseOrigin}/api/v1`;
(axios__WEBPACK_IMPORTED_MODULE_1___default().defaults.baseURL) = baseURL;
(axios__WEBPACK_IMPORTED_MODULE_1___default().defaults.withCredentials) = true;

const handle401 = () => {
  setTimeout(() => {
    var _window, _window$location, _window2, _window2$location;

    (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_4__/* .deleteToken */ .pQ)();
    window.location.href = (_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.href ? `/login?callback=${encodeURIComponent((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href)}` : '/login';
  }, 100);
};

const handleNotVerified = () => {
  setTimeout(() => {
    window.location.href = '/not-verified';
  }, 100);
};

axios__WEBPACK_IMPORTED_MODULE_1___default().interceptors.request.use(config => {
  const {
    ssrCtx
  } = config;
  const lang = _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF ? ssrCtx === null || ssrCtx === void 0 ? void 0 : ssrCtx.lang : (0,cookies_next__WEBPACK_IMPORTED_MODULE_3__.getCookie)(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .LANG_COOKIE */ .Yk);
  const currency = _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF ? ssrCtx === null || ssrCtx === void 0 ? void 0 : ssrCtx.currency : (0,cookies_next__WEBPACK_IMPORTED_MODULE_3__.getCookie)(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .CURRENCY_COOKIE */ .SM);
  const token = _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF ? ssrCtx === null || ssrCtx === void 0 ? void 0 : ssrCtx.token : (0,cookies_next__WEBPACK_IMPORTED_MODULE_3__.getCookie)(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .TOKEN_COOKIE */ .Md);
  const region = _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF ? ssrCtx === null || ssrCtx === void 0 ? void 0 : ssrCtx.region : (0,cookies_next__WEBPACK_IMPORTED_MODULE_3__.getCookie)(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .REGION_COOKIE */ .jO);
  const ua = _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF ? ssrCtx === null || ssrCtx === void 0 ? void 0 : ssrCtx.ua : '';

  if (config.method === 'get') {
    config.params = _objectSpread({}, config.params);
    config.data = {};
  } else {
    // 如果是FormData对象，不做处理
    if (!(config.data instanceof FormData)) {
      config.data = _objectSpread({}, config.data);
    }
  }

  config.headers = _objectSpread(_objectSpread(_objectSpread({}, _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF ? {
    'User-Agent': ua || ''
  } : {}), config.headers), {}, {
    Authorization: `Bearer ${token}`,
    'x-lang': lang,
    'x-currency': currency,
    'x-region': region
  });
  return config;
}, error => {
  _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"].error */ .Z.error('request fail');
  return Promise.reject(error);
});
axios__WEBPACK_IMPORTED_MODULE_1___default().interceptors.response.use(res => {
  var _res$config, _res$data4;

  if (!(res !== null && res !== void 0 && (_res$config = res.config) !== null && _res$config !== void 0 && _res$config.skipCodeCheck) && (res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.code) > 0) {
    var _res$data5;

    const code = res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.code;

    if (code === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .NOT_VERIFIED */ .MC) {
      _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || handleNotVerified();
    }

    if (![_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .BLUR_CODE */ .HH, _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .UNAUTHORIZED_CODE */ .BT].includes(code)) {
      var _res$data6;

      // 显示接口报错信息：http code == 200 & 业务 code > 0
      _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"].warning */ .Z.warning(res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.msg);
    }

    if (_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .BLUR_CODE */ .HH === code && !_utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF) {
      var _window3;

      if ((_window3 = window) !== null && _window3 !== void 0 && _window3.localStorage) {
        localStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .LOCAL_USERINFO_KEY */ .ch);
      }
    }
  }

  return res;
}, err => {
  const {
    status,
    data = {},
    config = {}
  } = (err === null || err === void 0 ? void 0 : err.response) || {};
  const {
    ssrCtx
  } = config;
  const lang = _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF ? ssrCtx === null || ssrCtx === void 0 ? void 0 : ssrCtx.lang : (0,cookies_next__WEBPACK_IMPORTED_MODULE_3__.getCookie)(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .LANG_COOKIE */ .Yk);
  const defaultFailMsg = lang === 'zh-CN' ? '抱歉，网站暂不可用，请稍后再试' : `Sorry, we've got a problem, please try again later`;
  const msg = (data === null || data === void 0 ? void 0 : data.msg) || defaultFailMsg;

  if (axios__WEBPACK_IMPORTED_MODULE_1___default().isCancel(err)) {// do noting
  } else if (status === 403) {
    _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || (window.location.href = '/403');
  } else if (status === 404) {
    _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || (window.location.href = '/404');
  } else if (status === 401) {
    _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || handle401();
  } else if (status === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .NOT_VERIFIED */ .MC) {
    _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || handleNotVerified();
  } else if (status === 429) {
    _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"].error */ .Z.error('请求过于频繁，请稍后再试!');
  } else if (status !== 200) {
    _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"].error */ .Z.error(msg);
  } else {
    // status = 200
    if (data.code && data.code > 0) {
      // 显示接口报错信息：http code == 200 & 业务 code > 0
      _utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isSSR */ .yF || _arco_design_web_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"].warning */ .Z.warning(msg);
    }
  }

  return Promise.reject(err);
});
/* harmony default export */ __webpack_exports__["ZP"] = ((axios__WEBPACK_IMPORTED_MODULE_1___default()));

/***/ }),

/***/ 47329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A7": function() { return /* binding */ uploadShopsImages; },
/* harmony export */   "E6": function() { return /* binding */ getTiktokShopUrl; },
/* harmony export */   "F0": function() { return /* binding */ publishShopsProduct; },
/* harmony export */   "K1": function() { return /* binding */ getTiktokShopCallback; },
/* harmony export */   "OR": function() { return /* binding */ getTiktokShopInfo; },
/* harmony export */   "WO": function() { return /* binding */ getShopsWarehouse; }
/* harmony export */ });
/* harmony import */ var _api_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84425);

// 获取一键上架授权链接
const getTiktokShopUrl = async () => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get(`/auth/shops/tiktok/redirect`);
}; // 店铺授权回调

const getTiktokShopCallback = async _ref => {
  let {
    code
  } = _ref;
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get(`/auth/shops/tiktok/callback`, {
    params: {
      code
    }
  });
};
const getTiktokShopInfo = async () => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get(`/users/shops/tiktok`);
};
const getShopsWarehouse = () => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get(`/users/shops/warehouse`);
};
const uploadShopsImages = data => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(`/tools/shops/upload-images`, data);
};
const publishShopsProduct = data => {
  return _api_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(`/tools/shops/publish`, data);
};

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(43611);
      }
    ]);
    if(false) {}
  

/***/ })

}]);